import React, {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {authPath, rootMainPath} from '../../../routes/paths';
import {postPassReset} from '../../../redux/actions/auth/authActions';
import InputMUI from '../../../shared/InputMUI';
import ButtonMUI from '../../../shared/ButtonMUI';
import EmailIcon from '../../../assets/icons/email.svg';
import passwordBg from '../../../assets/images/auth/password-img.jpg';
import passMob from '../../../assets/images/auth/pass-mob.jpg';
import Social from '../Social';
import {notifySuccess} from '../../../helpers/notifySnack';
import passIcon from '../../../assets/icons/pass.svg';
import {useTranslation} from 'react-i18next';
import {passwordRegex} from "../../../helpers/constants";

const PassReset = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const {buttonLoading} = useSelector(({app}) => app);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    useEffect(() => {
        localStorage.getItem('token') && history.push(rootMainPath);
        if (!token) {
            history.push('/')
        }
    }, []);

    const schema = yup.object({
        email: yup.string().email(t('validations.email')).required(t('validations.required')),
        password: yup.string().matches(passwordRegex, t('validations.password'))
            .required('validations.required'),
        passwordConfirm: yup
            .string()
            .required(t('validations.required'))
            .oneOf([yup.ref('password')], t('validations.notMatch'))
    });

    const {
        control,
        handleSubmit,
        formState: {errors, isValid, isSubmitting}
    } = useForm({
        mode: 'all',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        resolver: yupResolver(schema),
        defaultValues: {
            email: '',
            password: '',
            passwordConfirm: ''
        }
    });

    const onSubmit = async (data) => {
        try {
            const dataSend = {
                email: data.email,
                password: data.password,
                password_confirmation: data.passwordConfirm,
                token: token
            };

            const res = await dispatch(postPassReset(dataSend));
            if (res.payload && res.payload.status && res.payload.status === 200) {
                history.push(authPath.signIn);
                notifySuccess(t('all.successfully'));
            }
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <div className='auth-page__content'>
            <div className='auth-page__bg'>
                <img className='employee' src={passwordBg} alt='AuthBg'/>
            </div>
            <div className='auth-box__wrapper'>
                <div/>
                <form className='auth-box' onSubmit={handleSubmit(onSubmit)}>
                    <div className='auth-box__head'>
                        <div className='auth-box__mini-icon'>
                            <img src={passMob} alt='images'/>
                        </div>

                        <div className='auth-box__subtitle'>{t('auth.createPassword')}</div>
                        {/*<div className="auth-box__descriptions">*/}
                        {/*  {t("auth.sendEmail")}*/}
                        {/*</div>*/}
                    </div>

                    <div className='auth-box__input_wrapper'>
                        <div className='auth-box__input_box'>
                            <Controller
                                name='email'
                                control={control}
                                render={({field}) => (
                                    <InputMUI
                                        className='auth-box__input'
                                        type='email'
                                        fullWidth
                                        error={errors.email?.message}
                                        inputProps={field}
                                        label={t('auth.emailLabel')}
                                        startAdornment={EmailIcon}
                                    />
                                )}
                            />
                            <span className='input-info'>{t('auth.enterEmail')}</span>
                        </div>
                        <div className='auth-box__input_box'>
                            <Controller
                                name='password'
                                control={control}
                                render={({field}) => (
                                    <InputMUI
                                        className='auth-box__input'
                                        type='password'
                                        fullWidth
                                        error={errors.password?.message}
                                        inputProps={field}
                                        label={t('auth.passwordLabel')}
                                        startAdornment={passIcon}
                                    />
                                )}
                            />
                            <span className='input-info'>{t('auth.enterNewPassword')}</span>
                        </div>
                        <div className='auth-box__input_box'>
                            <Controller
                                name='passwordConfirm'
                                control={control}
                                render={({field}) => (
                                    <InputMUI
                                        className='auth-box__input'
                                        type='password'
                                        fullWidth
                                        error={errors.passwordConfirm?.message}
                                        inputProps={field}
                                        label={t('auth.confirmPasswordLabel')}
                                        startAdornment={passIcon}
                                    />
                                )}
                            />
                            <span className='input-info'>{t('auth.confirmNewPassword')}</span>
                        </div>

                        <ButtonMUI disabled={!isValid || buttonLoading} loading={isSubmitting} formAction>
                            {t('auth.submit')}
                        </ButtonMUI>
                    </div>

                    <div className='auth-box__info-text'>
                        <div className='text'>{t('auth.orAuthorize')}</div>
                    </div>

                    <Social/>
                </form>

                <div
                    className='auth-box__subscribe'>{t('SideBgFooter.copyright', {year: new Date().getFullYear()})}</div>
            </div>
        </div>
    );
};

export default PassReset;
